import { ButtonMode, HideIcon, ShowIcon } from 'edenred-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledToggleButton } from './/ToggleEstimationButton.styles';

interface ToggleEstimationButtonProps {
  estimationVisible: boolean;
  toggleEstimationVisibility: () => void;
}

export const ToggleEstimationButton = ({
  estimationVisible,
  toggleEstimationVisibility
}: ToggleEstimationButtonProps) => {
  const { t } = useTranslation();

  const toggleEstimationText = estimationVisible
    ? t('transfer_money.estimation_close')
    : t('transfer_money.estimation_open');

  const toggleEstimationIcon = estimationVisible ? <HideIcon /> : <ShowIcon />;

  return (
    <StyledToggleButton
      id="toggle-estimation-visibility-btn"
      type="button"
      mode={ButtonMode.Link}
      onClick={toggleEstimationVisibility}
    >
      {toggleEstimationIcon}
      {toggleEstimationText}
    </StyledToggleButton>
  );
};
